export const createDialogStyles = {
  inputGridContainer: {
    padding: "7px",
    width: "50vw",
  },
};
